<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

const props = defineProps<{
    class?: HTMLAttributes['class'];
    /**
     * Classes for the scroll container around the table.
     *
     * This element is the table's scrollport, so a bounded height here is what lets a `sticky`
     * header hold its place - against the page it would never stick, the container scrolling out of
     * view along with everything inside it.
     */
    containerClass?: HTMLAttributes['class'];
}>();
</script>

<template>
    <div :class="cn('relative max-w-full overflow-x-auto', props.containerClass)">
        <table :class="cn('w-full min-w-full caption-bottom text-normal', props.class)">
            <slot />
        </table>
    </div>
</template>
